import React, { useState, useRef } from "react";
import Compressor from "compressorjs";
import "../styles/UploadPage.css";

const UploadPinkpetPage = ({ authKey }) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [password, setPassword] = useState("");
  const [uidTag, setUidTag] = useState("");
  const [imageLink, setImageLink] = useState("");
  const [dragActive, setDragActive] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const passwordInputRef = useRef(null);
  const containerRef = useRef(null);
  const uploadimageUrl = process.env.REACT_APP_Upload_Image;

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    processFile(selectedFile);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = () => {
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    const droppedFile = e.dataTransfer.files[0];
    processFile(droppedFile);
  };

  const processFile = (selectedFile) => {
    if (!selectedFile) return;
    if (selectedFile.size > 5 * 1024 * 1024) {
      setError("⚠️ Plik musi być mniejszy niż 5MB!");
      setFile(null);
      setPreview(null);
      return;
    }

    setPreview(URL.createObjectURL(selectedFile));

    if (selectedFile.type === "image/gif") {
      setFile(selectedFile);
      return;
    }

    new Compressor(selectedFile, {
      quality: 0.4,
      maxWidth: 1024,
      success(compressedFile) {
        setFile(compressedFile);
        setError("");
      },
      error() {
        setError("❌ Błąd kompresji pliku!");
        setFile(selectedFile);
      },
    });
  };

  const handleUpload = async () => {
    if (!file) {
      setError("❌ Wybierz plik przed przesłaniem!");
      return;
    }

    if (!uidTag.trim()) {
      setError("❌ Podaj UID tagu!");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("password", password);
    formData.append("uid_tag", uidTag);

    setIsLoading(true);
    setError("");
    setUploadSuccess(false);
    setImageLink("");

    try {
      const response = await fetch(`${uploadimageUrl}?authKey=${authKey}`, {
        method: "POST",
        body: formData,
      });

      if (response.status === 409) {
        setError("❌ Ten UID tag już istnieje w bazie!");
        setIsLoading(false);
        return;
      }

      const data = await response.json();
      if (data.fileId) {

        await fetch(`${process.env.REACT_APP_Update_AppId}/${data.fileId}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ app_id: "pinkpet" }),
          });          

        setImageLink(`https://pinktouch.online/${data.fileId}`);
        setUploadSuccess(true);
      } else {
        setError(`🚨 Błąd: ${data.message || "Brak ID w odpowiedzi serwera"}`);
      }
    } catch (error) {
      setError("❌ Błąd przesyłania pliku");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div ref={containerRef} className="upload-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
      <div className="upload-card">
        <h2 className="upload-title">🔐 Upload PinkPet</h2>

        <div
          className={`upload-box ${dragActive ? "drag-active" : ""}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          {preview ? (
            <img src={preview} alt="Podgląd" className="upload-preview" />
          ) : (
            <>
              <div className="upload-icon">⬆️</div>
              <p className="upload-text">Przeciągnij plik tutaj lub kliknij</p>
              <p className="upload-size">Maksymalny rozmiar: <b>5MB</b></p>
            </>
          )}
        </div>

        <input type="file" id="upload-input" className="upload-input" onChange={handleFileChange} accept="image/*" />
        <label htmlFor="upload-input" className="upload-button file-button">Wybierz plik</label>

        <input
          type="text"
          className="upload-password"
          placeholder="🆔 UID tagu (np. z NFC)"
          value={uidTag}
          onChange={(e) => setUidTag(e.target.value)}
        />

        <input
          type="password"
          className="upload-password"
          placeholder="🔑 Opcjonalne hasło"
          value={password}
          ref={passwordInputRef}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          className={`upload-button ${isLoading ? "loading" : ""}`}
          onClick={handleUpload}
          disabled={isLoading}
        >
          {isLoading ? "🔄 Przesyłanie..." : "Prześlij"}
        </button>

        {uploadSuccess && imageLink && (
          <div className="upload-link-container fade-in">
            <p>📎 Twój link do obrazu:</p>
            <input className="upload-link" type="text" value={imageLink} readOnly />
            <button className={`upload-button copy-button ${copySuccess ? "copied" : ""}`} onClick={() => {
              navigator.clipboard.writeText(imageLink);
              setCopySuccess(true);
              setTimeout(() => setCopySuccess(false), 2000);
            }}>
              {copySuccess ? "✅ Skopiowano!" : "📋 Kopiuj link"}
            </button>
          </div>
        )}

        {error && <p className="upload-error fade-in">{error}</p>}
      </div>
    </div>
  );
};

export default UploadPinkpetPage;
